import React from "react"
import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import {Label, H2, H3, Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"
import mainTheme from "@irati/ui/src/global/theme"
import {ActiveCard} from "./styled"
import {useCountAvailableCustomRewardsQuery} from "@irati/custom-reward/hooks"

interface Props extends WithAuth {
  active: boolean
}
const CustomRewards = (props: Props) => {
  const idNamespace = id("balances", props)
  const {data} = useCountAvailableCustomRewardsQuery(null)
  const {active} = props
  const handleCardClick = () => {}
  return (
    <ActiveCard id={idNamespace} marginTop={5} active={active} onClick={handleCardClick}>
      <H3 color={mainTheme.colors.utility.ink} marginBottom={2}>
        <FormattedMessage id="wallet.walletBalanceCard.customRewards.title" />
      </H3>
      <Flex justifyContent="space-between">
        <Flex direction="column" id={id("available-balance", idNamespace)}>
          <Label color={mainTheme.colors.utility.contrast}>
            <FormattedMessage id="wallet.walletBalanceCard.available.header" />
          </Label>
          <H2 color={mainTheme.colors.primary2}>{data || 0}</H2>
        </Flex>
      </Flex>
      <div>
        <Body color={mainTheme.colors.utility.contrast} marginTop={2} marginBottom={2}>
          <FormattedMessage id="wallet.customRewards.info.text" />
        </Body>
      </div>
    </ActiveCard>
  )
}
export default withAuth(CustomRewards)
